import RewardPointsDisplay from "./RewardPointsDisplay";

export default RewardPointsDisplay;
